import { useContext, useState } from "react";
import { fetchData, GET_ALL_MOVIE_BY_CAT_LANG_ID, MOVIE_DISLIKE, MOVIE_LIKE, MOVIE_RATING } from "../../../components/Service";
import { useLocation, useParams } from "react-router-dom";
import { getEmbededYoutubeUrl } from "../../../components/Helper";
import { Context } from "../../../components/Context";
import { toast } from "react-toastify";

const MovieCard = (props) => {
	const [context] = useContext(Context);
	const [list, setList] = useState([]);
	const [notFound, setNotFound] = useState(false);
	const [likeCount, setLikeCount] = useState(props?.item?.total_likes);
	const [disLikeCount, setDisLikeCount] = useState(props?.item?.total_dislikes);
	const [rating, setRating] = useState(1);
	const [hover, setHover] = useState(0);

	const handleLike = () => {
		if (context?.userToken) {
			let payload = {
				user_id: context?.user?.user_id,
				country_id: context?.countryId,
				state_id: context?.stateId,
				video_id: props?.item?.id,
			};

			fetchData(MOVIE_LIKE, "POST", payload, true, false, (res) => {
				if (res.status) {
					const updatedLikes = likeCount + 1;
					const updatedCountDisLikes = disLikeCount === 0 ? 0 : disLikeCount - 1;

					setDisLikeCount(updatedCountDisLikes);
					setLikeCount(updatedLikes);
				} else {
					toast.error("Already Liked.");
				}
			});
		} else {
			window.$("#loginModal").modal("show");
		}
	};

	const handleDisLike = () => {
		if (context?.userToken) {
			let payload = {
				user_id: context?.user?.user_id,
				country_id: context?.countryId,
				state_id: context?.stateId,
				video_id: props?.item?.id,
			};

			fetchData(MOVIE_DISLIKE, "POST", payload, true, false, (res) => {
				if (res.status) {
					const updatedLikes = disLikeCount + 1;

					const updatedCountLikes = likeCount == 0 ? 0 : likeCount - 1;

					setLikeCount(updatedCountLikes);
					setDisLikeCount(updatedLikes);
				} else {
					toast.error("Already disliked.");
				}
			});
		} else {
			window.$("#loginModal").modal("show");
		}
	};

	const handleRating = () => {
		if (context?.userToken) {
			let payload = {
				user_id: context?.user?.user_id,
				movie_id: props?.item?.id,
				rating_data: rating,
			};

			fetchData(MOVIE_RATING, "POST", payload, true, false, (res) => {
				window.$(`#movieRatingModal_${props?.item?.id}`).modal("hide");
				if (res.status) {
					toast.success("Movie rating submitted successfully.");
				} else {
					toast.error("Unable to submit movie rating.");
				}
			});
		} else {
			window.$("#loginModal").modal("show");
		}
	};

	const showRatingModel = () => {
		if (context?.userToken) {
			window.$(`#movieRatingModal_${props?.item?.id}`).modal("show");
		} else {
			window.$("#loginModal").modal("show");
		}
	};

	return (
		<>
			<div key={props?.item?.id} class="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6 event_n mb-1">
				<div class="card-grid-2 hover-up h-100 mb-0">
					<div class="">
						<iframe src={getEmbededYoutubeUrl(props?.item?.link)} title="YouTube Video" allowFullScreen />
					</div>
					<div class="card-block-info position-relative">
						<h6>{props?.item?.name}</h6>
						<div class="card-2-bottom mt-30">
							<div class="row d-flex ">
								<div class="col-6 align-self-stretch">
									<ul className="point-list">
										<li className="fw-bold me-3" onClick={handleLike}>
											<span className="bg-success">
												<i class="fi fi-sr-thumbs-up text-white"></i>
											</span>{" "}
											{likeCount}
										</li>
										<li className="fw-bold" onClick={handleDisLike}>
											<span className="bg-danger">
												<i class="fi fi-sr-thumbs-down text-white"></i>
											</span>{" "}
											{disLikeCount}
										</li>
									</ul>
								</div>
								<div class="col-6 align-self-stretch">
									<div className="h-100 d-flex align-items-center h6">
										{" "}
										<i class="fi fi-sr-star text-warning"></i> <span className=" ms-1">{props?.item?.rating ?? 0}</span>{" "}
										<a class="btn btn-apply-now ms-auto" href="#!" onClick={showRatingModel}>
											Rate us
										</a>{" "}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="modal fade pe-0"
				id={`movieRatingModal_${props?.item?.id}`}
				data-bs-backdrop="static"
				data-bs-keyboard="false"
				tabindex="-1"
				aria-labelledby="staticBackdropLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
					<div className="modal-content apply-job-form">
						<button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
						<div className="modal-header d-block text-center border-bottom-0">
							<h5 className="text-brand-1 text-capitalize">Rate This Movie</h5>
						</div>
						<div className="modal-body px-4 pb-4">
							<div className="row">
								<div className="col-12 mb-2 d-flex justify-content-center">
									<div className="rating mt-2">
										{[...Array(5)].map((_, index) => {
											const starValue = index + 1;
											return (
												<label key={starValue}>
													<input type="radio" name="rating" value={starValue} onClick={() => setRating(starValue)} />
													<span
														className="star"
														style={{
															color: starValue <= (hover || rating) ? "#ffcc00" : "#ccc",
														}}
														onMouseEnter={() => setHover(starValue)}
														onMouseLeave={() => setHover(0)}
													>
														&#9733;
													</span>
												</label>
											);
										})}
									</div>
								</div>
							</div>
							<div className=" d-block text-center mt-2 mb-3">
								<button className="btn btn-default hover-up m-auto" type="submit" onClick={handleRating}>
									Submit Rating
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default MovieCard;
